const geoUrlBase = process.env.REACT_APP_GEO_API_URL;
const apiUrlBase = process.env.REACT_APP_ENERGY_DASHBOARD_API_URL;

const buildingJobInfo = (projectId: string | undefined) => `${geoUrlBase}/scene/jobs/project/${projectId}`;
const create = () => `${geoUrlBase}/scene/pipeline`;
const jobStatus = (jobId: string) => `${geoUrlBase}/scene/jobs/${jobId}`;
const outline = () => `${geoUrlBase}/building/outline`;
const submittedBuildingInfo = (projectId: string | undefined) => `${apiUrlBase}/api/projects/${projectId}/dt-basic`;
const updateBuilding = () => `${geoUrlBase}/scene/pipeline/update`;
const uploadRootDestPath = () => `dtbasicsetup/data`;

const epcExtract = () => `${geoUrlBase}/epc/extract`;

const addBuildingUrls = {
  buildingJobInfo,
  create,
  epcExtract,
  jobStatus,
  outline,
  submittedBuildingInfo,
  updateBuilding,
  uploadRootDestPath,
};

export default addBuildingUrls;
